import { render, staticRenderFns } from "./AdminLogList.vue?vue&type=template&id=d04b427c&"
import script from "./AdminLogList.vue?vue&type=script&lang=js&"
export * from "./AdminLogList.vue?vue&type=script&lang=js&"
import style0 from "./AdminLogList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports